import React, {useState} from 'react';
import {Button, Col, Modal, Row} from 'react-bootstrap';
import MDSpinner from 'react-md-spinner';

const ConfirmationSaveModal = ({onSaveWith, onSave, onHide, message}) => {
    const [loadingType, setLoadingType] = useState(null);

    const resetLoading = () => setLoadingType(null);

    return (
        <Modal
            bsSize='small'
            show={true}
            onHide={onHide}
            backdrop='static'
            id='confirmation-modal'
            className='heightAuto fontIOS'
        >
            <Modal.Header>
                <Modal.Title>Confirm saving</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <h4 className='text-center'>{message}</h4>
            </Modal.Body>
            <Modal.Footer>
                <Row>
                    <Col xs={12}>
                        <Button
                            bsSize='small'
                            bsStyle='success'
                            disabled={!!loadingType}
                            onClick={() => {
                                setLoadingType('new');
                                onSaveWith(
                                    () => {
                                        resetLoading();
                                        onHide();
                                    },
                                    () => {
                                        resetLoading();
                                    },
                                );
                            }}
                        >
                            {loadingType === 'new' ? (
                                <div className='vertical-align'>
                                    <MDSpinner size={20} className='mr-5' /> Processing...
                                </div>
                            ) : (
                                'Create new Primary Site'
                            )}
                        </Button>

                        <Button
                            bsSize='small'
                            bsStyle='success'
                            disabled={!!loadingType}
                            onClick={() => {
                                setLoadingType('update');
                                onSave();
                                onHide();
                            }}
                        >
                            {loadingType === 'update' ? (
                                <div className='vertical-align'>
                                    <MDSpinner size={20} className='mr-5' /> Processing...
                                </div>
                            ) : (
                                'Update Primary Site and Events'
                            )}
                        </Button>

                        <Button
                            bsSize='small'
                            bsStyle='warning'
                            disabled={!!loadingType}
                            onClick={() => onHide()}
                        >
                            Close without Save
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmationSaveModal;